module.exports = __webpack_public_path__ + "static/img/image_news_over_05.5d70844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_05.png
// module id = wtW0
// module chunks = 10